import {
  apiRequest,
  riwayatangkakreditList,
  riwayatangkakreditActive,
  riwayatangkakreditInactive,
  riwayatangkakreditListJabfung,
  SyncronizeJabfung,
  getuserpkpm
} from "../../../../../services/adapters/kepegawaian/riwayatangkakreditService";

class DataTableRepository {
  fetchRowTable = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      riwayatangkakreditList,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchJabfungTable = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      riwayatangkakreditListJabfung,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchActive = async (query) => {
    return await apiRequest(
      "post",
      riwayatangkakreditActive,
      {
        body: query,
      },
      true
    );
  };

  fetchInactive = async (query) => {
    return await apiRequest(
      "post",
      riwayatangkakreditInactive,
      {
        body: query,
      },
      true
    );
  };

  SyncronizeJabfung = async (query) => {
    return await apiRequest(
      "get",
      SyncronizeJabfung,
      {
        params: query,
      },
      true
    );
  };

  fetchgetuserpkpm = async (query) => {
    return await apiRequest(
      "get",
      getuserpkpm,
      {
        params: query,
      },
      true
    );
  };
}

export default DataTableRepository;
